export default "__VITE_ASSET__BG9FdB8J__"